const Constants = require("./constants");

const configuration = {

    project: "bypay-local",

    baseUrl: Constants.BASE_URL,

    default_port: 3008,
    default_ratio_exange_eur_byto: 1.5,

    payerComission: 0.05, // f2
    receiverComission: 0.05, // f1
    platformComission: 0.00,
    factorComission: 0.02,

    fakeSsl: false,
    rossumEnabled: false,
    useHedera: false,

    // Database
    database: {
        // Localhost
        url: 'mongodb://localhost:27017/byppay'
    },
    databasetest: {
        // Localhost test
        url: 'mongodb://localhost:27017/bypayTest'
    },

    // Available Networks
    networks: {

        localhost: {
            name: "localhost",
            seed: "localhost",
            host: "http://127.0.0.1:8545",
            gasPrice: 0,
        },

        alastria: {
            name: 'alastria',
            seed: "factoring cobi2020 telsius",
            gasPrice: 0,
            host: "http://n1.rabbit.centreeasy.com/rpc"
        },

        telsius_test: {
            name: 'alastria',
            seed: "factoring cobi2020 telsius test",
            gasPrice: 0,
            host: "http://n2.rabbit.centreeasy.com/rpc"
        },
    },
    SocialLogin: {
        facebook: {
            clientID: Constants.LOGIN_SOCIAL.FACEBOOK_ID,
            clientSecret: "bf9452e9b339dce8bd0d73b8528164cf",
            callbackURL: "http://localhost:3008/api/auth/facebook/callback"
        },
        google: {
            clientID: Constants.LOGIN_SOCIAL.GOOGLE_ID,
            clientSecret: "jd4OlKeMDvENNVdaMpkOeBMq",
            callbackURL: "http://localhost:3008/api/auth/google/callback"
        }
    },
    rabbitQM: {
        connection: {
            name: 'default',
            host: 'localhost',
            user: 'guest',
            pass: 'guest'
        }
    },

    smart_contract_file: "../contracts.local.json",

    // Number of actions to process at the same time
    actionThreads: 10,

    // Push notifications
    pushNotifications: {
        email: 'FactoringCentreEasy@gmail.com',
        publicKey: 'BDq1HMRI9tL2xGMunv11V27KpR6Np53MUKheDxPz8Nz2EBaRO59EtbMJWd7WaAk0smnnmTBptM9kMHFulO2Gdj0',
        privateKey: 'Z4LxauakOfH6E8miZvzNdF0qizcz9ZSy9Th-zwbkMgA'
    },

    // Must be GMAIL
    email: {
        socketlabs: true,
        host: "smtp.socketlabs.com",
        port: 587,
        secure: false,
        user: "server35216",
        address: "no-reply@byppay.com",
        password: "Ae54Tfz3CYc6y9D8",
        socketlabs_id: 35216,
        socketlabs_key: "Kb56Wpj7G8SdTk43Jei2"
    },

    // Rossum network
    rossum: {
        email: "factoringemail@gmail.com",
        password: "H6PUVxnw6PKdbr16",
        queue: "46562"
    },

    hedera: {
        OPERATOR_ID: "0.0.65068",
        OPERATOR_KEY: "302e020100300506032b657004220420d9a44d5777d64bd538381493bcb4511e95e406594a50557e1c936766d11407cf",
        //SMART_CONTRACT_FILE_ID: "0.0.66954",
        //SMART_CONTRACT_ID: "0.0.68393"
        SMART_CONTRACT_FILE_ID: "0.0.71980",
        SMART_CONTRACT_ID: "0.0.71981"
    },

    stripe: {
        //private_key: "sk_test_51HPNIaJmvzOT41paF3snKtKxHnaJTPKvrlwtW1g08f5PGsDm5M4PHx95jVLiNhX0pOiy8chrINsA2SJMQ8r4Cx4Z00NRqrhvTu"
        public_key: "",
        private_key: ""
    },
    wallets: {
        dao: {
            wallet: "",
            percentage: 0
        },
        foundersAndInvestors: {
            wallet: "",
            percentage: 0
        },
        Marketing: {
            wallet: "",
            percentage: 0
        },
        ManagementTeam: {
            wallet: "",
            percentage: 0
        },
        Liquidity: {
            wallet: "",
            percentage: 0
        },
        StakingRewards: {
            wallet: "",
            percentage: 0
        },
        Raffles: {
            wallet: "",
            percentage: 0
        },
        Root: {
            wallet: "0x596Ae53D0f9dd2660a7d28ef24524f70E195736e",
        }
    },

    URL_NODE: '',
    walletMoneder: {
        address: '',
        privateKey: '',
    },
};

// Export configuration
module.exports = configuration;
